import fs from "fs";
import _ from "lodash";

export const crawl = (user, allValues) => {
  if (!allValues) allValues = [];
  for (var key in user) {
    if (typeof user[key] === "object") crawl(user[key], allValues);
    else allValues.push(user[key] + " ");
  }
  return allValues;
};

export const removeDupes = (myArr) => {
  let myArrSerialized = myArr.map((e) => JSON.stringify(e));

  const mySetSerialized = new Set(myArrSerialized);
  const myUniqueArrSerialized = [...mySetSerialized];
  const myUniqueArr = myUniqueArrSerialized.map((e) => JSON.parse(e));
  // console.log(myUniqueArr.length);
  return myUniqueArr;
};

export const arrComparer = (compArr) => {
  return function (current) {
    return (
      compArr.filter(function (other) {
        return (
          other.application_id == current.application_id &&
          // other.current_name == current.current_name &&
          other.application_name == current.application_name &&
          other.activity_name == current.activity_name &&
          other.domain_name == current.domain_name
        );
      }).length == 0
    );
  };
};

export const getNextMonday = () => {
  try {
    const dateCopy = new Date();

    const nextMonday =
      dateCopy.getDay() == 3
        ? dateCopy
        : new Date(
            dateCopy.setDate(
              dateCopy.getDate() + ((7 - dateCopy.getDay() + 3) % 7 || 7)
            )
          );

    return nextMonday.toLocaleDateString();
  } catch (err) {
    console.log(err);
  }
};

export const fsStore = (myArr, name) => {
  try {
    // convert JSON object to string
    const jsa = JSON.stringify(myArr);

    // write JSON string to a file
    fs.writeFile(name + ".json", jsa, (err) => {
      if (err) {
        throw err;
      }
      console.log("JSON data is saved.");
    });
  } catch (err) {
    console.log(err);
  }
};

export function uniqueByKey(array, key) {
  try {
    return [...new Map(array.map((x) => [x[key], x])).values()];
  } catch (err) {
    console.log(err);
    return [];
  }
}

export const processSum = (omitKey, data) => {
  try {
    return _.omit(
      _.mergeWith(
        {},
        ...data,
        (objValue = 0, srcValue = 0) => +objValue + +srcValue
      ),
      omitKey
    );
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const catComp = (data, a, b) => {
  let leCounter = 0;
  let deCounter = 0;
  try {
    data.map((x) => {
      !_.isEqual(
        x[a].replace(/\s/g, "").split(",").sort(),
        x[b].replace(/\s/g, "").split(",").sort()
      )
        ? leCounter++
        : deCounter++;
    });
    return [leCounter, deCounter];
  } catch (err) {
    console.log(err);
    return [leCounter, deCounter];
  }
};

export const searchRec = (list, text, key) =>
  list.filter((i) => i[key].toLowerCase().includes(text.toLowerCase()));

export const getArrDists = (jsArr) => {
  try {
    return _.union(jsArr.join(",").split(",").sort());
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const reduceMap = (arrA, arrB) => {
  try {
    return _.difference(arrA, arrB).length === 0;
  } catch (err) {
    console.log(err);
    return null;
  }
};
